import { PHOTO_BUTTON_DISABLED, PHOTO_BUTTON_HIDDEN } from "../constants"

/* eslint-disable no-underscore-dangle */
export default class ButtonElement {
  /**
   * Creates an instance of ButtonElement.
   * @param {HTMLAnchorElement | HTMLButtonElement} element
   * @param {String} direction
   * @memberof ButtonElement
   */
  constructor(element, direction) {
    this.element = element
    this.direction = direction

    this._onClickCallbackList = []
    this.element.addEventListener("click", (event) => {
      event.preventDefault()
      this._onClickCallbackList.forEach((callback) => callback(this.direction))
    })
  }

  /**
   * @param {function() : void} callback
   * @memberof ButtonElement
   */
  onClick(callback) {
    this._onClickCallbackList.push(callback)
  }

  /**
   * @param {Boolean} shouldBeHidden
   * @memberof ButtonElement
   */
  toggleVisibility(shouldBeHidden) {
    this.element.classList.toggle(PHOTO_BUTTON_HIDDEN, shouldBeHidden)
  }

  /**
   * @param {Boolean} shouldBeDisabled
   * @memberof ButtonElement
   */
  toggleDisableState(shouldBeDisabled) {
    this.element.classList.toggle(PHOTO_BUTTON_DISABLED, shouldBeDisabled)
  }
}
